<div id="main" class="relative overflow-hidden" #mainCt>
  <!-- NAVBAR: Left -->
  <ng-container #leftNavBar></ng-container>
  @defer (when toolbarService.leftSidebarToggleOpen()) {
    <left-navbar></left-navbar>
  }
  
  <!-- / NAVBAR: Left -->

  <ng-scrollbar id="main-scrollbar" class="sb-accent sb-block h-screen" visibility="hover" orientation="vertical" scrollbarRef [sensorThrottleTime]="0">
    <div class="sticky top-0 z-40">
      <toolbar [style.visibility]="toolbarService.hideToolbar() ? 'hidden' : 'visible'"></toolbar>
    </div>

    <div id="mainContent"  class="will-change-transform" [class.solid]="toolbarService.isSolid()"
    [@routeAnimations]="routerAnimation" (@routeAnimations.done)="routerAnimDone($event)">
      <router-outlet id="mainOutlet" #outlet="outlet" (activate)="setAnimation(outlet)"></router-outlet>
    </div>
    <router-outlet #fOutlet="outlet" id="footerOutlet" name="footerOutlet"></router-outlet>
  </ng-scrollbar>

  <router-outlet #mOutlet="outlet" id="mobileinfoBarOutlet" name="mobileinfoBarOutlet"></router-outlet>

  <!--Bug timer ssr  https://github.com/angular/angular/issues/55475 -->
  <!-- @defer (on timer(5s)) { -->
  @defer () { 
    <scroll-top></scroll-top>
  }
  
  <!-- aggiunto componente per scroll top -->

    <!-- NAVBAR: Right -->
  @defer (when toolbarService.rightSidebarToggleOpen()) {
    <right-navbar></right-navbar>
  }
  <!-- / NAVBAR: Right -->
<!-- 
  @defer (on timer(3s)) {
    <router-outlet #fOutlet="outlet" id="newsCarouselOutlet" name="newsCarouselOutlet" *renderIf="{mediaSelector:'gt-md'}"></router-outlet>
  } -->
</div>

